module.exports = __webpack_public_path__ + "static/media/gif_menu.fbc25ff3.gif";